<div class="container-title-slider">
    <p>
        {{title}}
        <span>({{items.length}})</span>
    </p>
    <div
        *ngIf="items.length > 3"
        class="container-btn"
    >
        <navaar-button
            *ngIf="false"
            (onClick)="goToListAgents()"
            [type-button]="'button'"
            [color-name]="'blue'"
        >
            <span>همه</span>
            <img
                src="assets/icon-new/Icon-Chevron-Left.svg"
                alt="Icon-Chevron-Left"
            >
        </navaar-button>
    </div>
</div>

<ng-template
    [ngIf]="items.length > 3"
    [ngIfElse]="singleItem"
>
    <div class="container-main-slider">
        <div class="wrapper-container">
            <ng-template
                ngFor
                [ngForOf]="items"
                let-item
                let-i="index"
                [ngForTrackBy]="trackByFn"
            >
                <div
                    (click)="goToAgentsPage(item.id, item.name)"
                    class="items"
                >
                    <div class="container-img">
                        <img
                            [lazySrc]="item.image"
                            lazySrcVisible="visible"
                            src="assets/icon-new/user-empty.svg"
                            class="wrapper-img-slider"
                            [alt]="'item.title'"
                        >
                    </div>
                    <div class="container-desc">
                        <h2 class="truncate">
                            <span [textContent]="item.name"></span>
                        </h2>
                        <p [textContent]="item.title"></p>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-template>

<ng-template #singleItem>

    <div class="container-main-slider">
        <div class="wrapper-container">
            <ng-template
                ngFor
                [ngForOf]="items"
                let-item
                let-i="index"
                [ngForTrackBy]="trackByFn"
            >
                <div class="container-single-artist">
                    <div class="wrapper-header">
                        <img
                            [lazySrc]="environment.imageUrl +'/content/Artists/'+ item.artistId +'/pic.jpg?t=' + item.recordVersion"
                            lazySrcVisible="visible"
                            src="assets/img/placeholder.png"
                            class="wrapper-img-slider"
                            [alt]="item.name"
                        >
                        <div class="wrapper-header-text">
                            <div>
                                <p [textContent]="item.name"></p>
                                <p [textContent]="item.title"></p>
                            </div>
                            <!-- <div>
                                <p [textContent]="1920"></p>
                                <p>دنبال کننده</p>
                            </div> -->
                            <div class="hr-style"></div>
                        </div>
                    </div>
                    <div class="wrapper-single-desc">
                        <p class="truncate-description">
                            {{item.description}}
                            <span
                                class="more-text-style"
                                (click)="goToAgentsPage(item.id, item.name)"
                            >
                                ادامه مطلب...
                            </span>
                        </p>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-template>
